import React from "react";
import { useState, useRef, useEffect } from "react";
import "./Dropdown.css";
import { toTitleCase } from "utlis/utils";

const options = ["metro", "non metro"];

export default function RoomRentDropdown({ selectionHandler, setSelectionHandler }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(options[0]);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
    // selectionHandler(value);
    setSelectionHandler(value.replace(" ", "_").toLowerCase())
  };

  return (
    <div ref={dropdownRef} className={`dropdown ${open ? "show" : ""}`}>
      <button className="dropbtn" onClick={() => setOpen((prev) => !prev)}>
        <span>{toTitleCase(selected)}</span>

        <svg
          className="dropdown-chevron"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M7 10L12 15L17 10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <div className="dropdown-content">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            className={`dropdown-item ${selected === option ? "selected" : ""}`}
            onClick={() => handleSelect(option)}
          >
            {toTitleCase(option)}
          </button>
        ))}
      </div>
    </div>
  );
}
